import styled from 'styled-components';

export const DialogTitleDefaultBox = styled.div`
    flex-grow: 1;
    color: ${props => props.theme.colors.textLight};
    ${({theme}) => theme.font.presets.body};
    line-height: normal;
    text-transform: capitalize;
    font-size: 1.4em;
    letter-spacing: 0.98px;
    text-align: center;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        text-align: left;
    }
`;
